import React from "react";

import { Route, Switch, useRouteMatch, Redirect } from "react-router-dom";

import useHasRole from "../../lib/hooks/useHasRole";

import SettingsRouter from "./Settings";
import Settings2faRouter from "./Setup2fa";

const ProfileRouter = React.memo(() => {
  const { path } = useRouteMatch();

  const isServiceEmployee = useHasRole(["SERVICE_EMPLOYEE"]);

  return (
    <Switch>
      <Route exact path={path}>
        <SettingsRouter />
      </Route>
      {!isServiceEmployee && (
        <Route exact path={`${path}/setup-2fa`}>
          <Settings2faRouter />
        </Route>
      )}
      <Redirect to={path} />
    </Switch>
  );
});

export default ProfileRouter;
